import { render, staticRenderFns } from "./BasisSmsCode.vue?vue&type=template&id=d1c85330&scoped=true&"
import script from "./BasisSmsCode.vue?vue&type=script&lang=js&"
export * from "./BasisSmsCode.vue?vue&type=script&lang=js&"
import style0 from "./BasisSmsCode.vue?vue&type=style&index=0&id=d1c85330&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c85330",
  null
  
)

export default component.exports